import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'fleet-profile-jumbotron',
  templateUrl: './profile-jumbotron.component.html',
  styleUrl: './profile-jumbotron.component.scss',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  encapsulation: ViewEncapsulation.None,
})
export class ProfileJumbotronComponent {
  @Input() userProfile: any;

  constructor() {

  }
}
